export type CardCategory =
  | 'bondage'
  | 'impact'
  | 'sensation'
  | 'service'
  | 'psychological'
  | 'primal'
  | 'exhibition'
  | 'lifestyle'
  | 'edge';

export type ColumnId = 'deck' | 'hard' | 'soft' | 'curious' | 'yes' | 'hellyes';

export interface Card {
  id: string;
  name: string;
  description: string;
  category: CardCategory;
  advanced?: boolean;
}

export interface Column {
  id: ColumnId;
  label: string;
  hint: string;
  /** Accent color, used for left edge stripe. */
  accent: string;
}

export const COLUMNS: Column[] = [
  { id: 'deck', label: 'the deck', hint: 'unsorted', accent: '#C9A96E' },
  { id: 'hard', label: 'hard limit', hint: 'never', accent: '#3D0810' },
  { id: 'soft', label: 'soft limit', hint: 'maybe, with care', accent: '#A88817' },
  { id: 'curious', label: 'curious', hint: 'interested but uncertain', accent: '#7A5C8F' },
  { id: 'yes', label: 'yes', hint: 'wanted', accent: '#C9A96E' },
  { id: 'hellyes', label: 'hell yes', hint: 'wanted with intensity', accent: '#B8466B' },
];

export const SORT_COLUMNS: Column[] = COLUMNS.filter((c) => c.id !== 'deck');

export type SortState = Record<string, ColumnId>;
